export default __webpack_public_path__ + "static/media/9.7aa356a9.png";